<app-bciti-tabs>
  <app-bciti-tab *ngIf="isComponentDisplayed('admin-config-cards')" [title]="'pages.config-all.tabs.cards' | translate">
    <app-config-cards></app-config-cards>
  </app-bciti-tab>
  <app-bciti-tab *ngIf="isComponentDisplayed('admin-config-family')" [title]="'pages.config-all.tabs.family' | translate">
    <app-config-family></app-config-family>
  </app-bciti-tab>
  <app-bciti-tab [title]="'pages.config-all.tabs.residence' | translate">
    <app-config-residence></app-config-residence>
  </app-bciti-tab>
</app-bciti-tabs>
